import * as React from 'react';

import type { EmbeddedPromoTemplatePageContextType } from 'bundles/page-config-common/contexts/enterprise/EmbeddedPromoTemplatePageContext';
import EmbeddedPromoTemplatePageContext from 'bundles/page-config-common/contexts/enterprise/EmbeddedPromoTemplatePageContext';
import useEmbeddedPageContentQuery from 'bundles/promo-template/queries/hooks/useEmbeddedPageContentQuery';

type Props = {
  slug: string;
  domain: string;
};

const EmbeddedPromoTemplatePageProviderWrapper = ({ slug, domain, children }: React.PropsWithChildren<Props>) => {
  const contextValue: EmbeddedPromoTemplatePageContextType = {
    page: undefined,
  };
  const skip = !slug || !domain;
  const { loading, page, error } = useEmbeddedPageContentQuery(slug, domain, skip);

  if (!skip && !error && !loading && page) {
    contextValue.page = page;
  }

  return (
    <EmbeddedPromoTemplatePageContext.Provider value={contextValue}>
      {children}
    </EmbeddedPromoTemplatePageContext.Provider>
  );
};

export default EmbeddedPromoTemplatePageProviderWrapper;
